import axios from '@/libs/api.request'
// 获取消息提醒
export const getMessageHome = data => {
  return axios.request({
    url: '/message/home',
    data,
    method: 'POST'
  })
}
// 获取消息列表
export const getMessagePage = data => {
  return axios.request({
    url: '/message/page',
    data,
    method: 'POST'
  })
}
// 标记为已读
export const subMessageRead = data => {
  return axios.request({
    url: '/message/read',
    data,
    method: 'POST'
  })
}
// 标记所有为已读
export const subMessageReadAll = data => {
  return axios.request({
    url: '/message/read/all',
    data,
    method: 'POST'
  })
}
